export default function CompanyOverview() {
  const stats = [
    { number: '80+', label: 'Partnered Distributors' },
    { number: '70+', label: 'Years Experience' },
    { number: '24/7', label: 'Support Available' }
  ];

  return (
    <section id="overview" className="bg-[#F8F9FA] py-16 md:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <span className="text-[#0D1B3E] text-xs md:text-sm font-semibold tracking-[0.15em] uppercase">
            WHO WE ARE
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0D1B3E] mt-4 md:mt-6 mb-6 md:mb-8">
            Powering Industrial Excellence Since 1995
          </h2>
          <p className="text-base md:text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto px-4">
            For over 70+ years, Superior Equipment and Technology has been dedicated to supporting Hawaii's facilities management and industrial operations with high-quality components and reliable solutions. We proudly serve hotels, property management companies, the military, public works, hospitals, municipalities, water and wastewater facilities, and commercial HVAC and plumbing contractors. As a locally rooted company, we specialize in sourcing hard-to-find equipment and delivering the right solutions with exceptional service and trusted expertise.
          </p>
        </div>

        {/* Statistics Bar */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="relative">
              <div className="text-center py-6 md:py-8">
                <div className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#0066FF] mb-3 md:mb-4">
                  {stat.number}
                </div>
                <div className="text-sm md:text-base text-gray-700 font-medium">
                  {stat.label}
                </div>
              </div>
              {index < stats.length - 1 && (
                <div className="hidden md:block absolute right-0 top-1/2 transform -translate-y-1/2 w-px h-20 bg-gray-300"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
